import api from "./server";

export const uploadResume = async (file, userId, category, stage) => {
  const formData = new FormData();
  formData.append('resume', file);
  formData.append('user_id', userId);
  formData.append('category', category);
  if (stage !== undefined && stage !== null) {
    formData.append('stage', stage);
  }

  const response = await api.post('/resume/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

// Analyze resume
export const analyzeResume = async (filename, user_id, category, stage) => {
  const response = await api.post('/resume/analyze', { filename, user_id, category, stage });
  return response.data;
};

// Create career transition resume
export const createTransitionResume = async (data) => {
  const response = await api.post('/resume/create', data);
  return response.data;
};

// Enhance existing resume
export const enhanceResume = async (filename) => {
  const response = await api.post('/resume/enhance', { filename });
  return response.data;
};

// Health check
export const healthCheck = async () => {
  const response = await api.get('/health');
  return response.data;
};

/**
 * AI-Powered Gap Analysis
 */
export async function analyzeGapWithAI(resumeData, targetRole, jobDescription, user_id, category, stage) {
  const response = await api.post('/resume/analyze-gap', { resumeData, targetRole, jobDescription, user_id, category, stage });
  return response.data.analysis;
}

/**
 * AI-Powered ATS Analysis for Preview Page
 */
export async function analyzeATSWithAI(resumeText, targetRole, user_id, category) {
  const response = await api.post('/resume/analyze-ats', { resumeText, targetRole, user_id, category });
  return response.data.analysis;
}

export const getCredits = async (user_id, category) => {
  const response = await api.get(`/resume/credits?user_id=${user_id}&category=${category}`);
  return response.data;
};

export const saveResumeProgress = async (userId, category, stage, step, appState) => {
  const response = await api.post('/resume/save-progress', {
    user_id: userId,
    category,
    stage,
    step,
    appState
  });
  return response.data;
};

export const getUserResumes = async (userId, category) => {
  const response = await api.get(`/resume/all/${userId}/${category}`);
  return response.data;
};

export const getLatestResume = async (userId, category) => {
  const response = await api.get(`/resume/latest/${userId}/${category}`);
  return response.data;
};

export const updateResumeData = async (id, data, downloadUrl = null) => {
  const { step, targetRole, jobDescription, ...rest } = data;
  const response = await api.patch(`/resume/update/${id}`, { 
    parsed_data: rest,
    step: step,
    target_role: targetRole,
    job_description: jobDescription,
    ...(downloadUrl && !downloadUrl.startsWith('blob:') ? { download_url: downloadUrl } : {})
  });
  return response.data;
};

export const logEvent = async (eventType, metadata = {}) => {
  try {
    await api.post('/resume/event', { eventType, metadata });
  } catch (error) {
    console.error('Failed to log event:', error);
  }
};

/**
 * Convert HTML to PDF using backend Puppeteer service
 */
export const convertHtmlToPdf = async (htmlContent, fileName) => {
  const response = await api.post('/resume/html-to-pdf', 
    { htmlContent, fileName }, 
    { responseType: 'blob' }
  );
  return response.data; // This will be a Blob
};

/**
 * Submit feedback for the resume builder
 */
export const submitResumeFeedback = async (data) => {
  try {
    const response = await api.post('/resume/feedback', data);
    return response.data;
  } catch (error) {
    console.error('Failed to submit feedback:', error);
    throw error;
  }
};